import React from 'react';
import { ArrowLeft, ArrowRight } from '../../public/icons';

const Pagination = ({ 
  currentPage = 1, 
  totalPages = 16, 
  itemsPerPage = 10, 
  totalItems = 312,
  onPageChange 
}) => {
  const renderPageNumbers = () => {
    const pages = [];
    
    // Always show first page
    pages.push(
      <button
        key={1}
        onClick={() => onPageChange(1)}
        className={`py-1.5 sm:py-2 md:py-2.5 px-2 sm:px-3 md:px-4 min-w-[28px] sm:min-w-[35px] md:min-w-[40px] text-xs sm:text-sm md:text-base ${
          currentPage === 1
            ? 'bg-[#55000C] text-white'
            : 'text-[#1C2A46] hover:bg-gray-50 border border-[#DBDBDB]'
        }`}
      >
        1
      </button>
    );

    // Show current page and surrounding pages if not first page
    if (currentPage > 1) {
      if (currentPage > 3) {
        pages.push(<span key="ellipsis1" className="py-1.5 sm:py-2 md:py-2.5 px-1 sm:px-2 text-[#6B635D] text-xs sm:text-sm">...</span>);
      }
      
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(
          <button
            key={i}
            onClick={() => onPageChange(i)}
            className={`py-1.5 sm:py-2 md:py-2.5 px-2 sm:px-3 md:px-4 min-w-[28px] sm:min-w-[35px] md:min-w-[40px] text-xs sm:text-sm md:text-base ${
              currentPage === i
                ? 'bg-[#55000C] text-white'
                : 'text-[#1C2A46] hover:bg-gray-50 border border-[#DBDBDB]'
            }`}
          >
            {i}
          </button>
        );
      }
    }

    // Show ellipsis and last page if needed
    if (currentPage < totalPages - 2) {
      pages.push(<span key="ellipsis2" className="py-1.5 sm:py-2 md:py-2.5 px-1 sm:px-2 text-[#6B635D] text-xs sm:text-sm">...</span>);
    }
    
    if (totalPages > 1) {
      pages.push(
        <button
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          className={`py-1.5 sm:py-2 md:py-2.5 px-2 sm:px-3 md:px-4 min-w-[28px] sm:min-w-[35px] md:min-w-[40px] text-xs sm:text-sm md:text-base ${
            currentPage === totalPages
              ? 'bg-[#55000C] text-white'
              : 'text-[#1C2A46] hover:bg-gray-50 border border-[#DBDBDB]'
          }`}
        >
          {totalPages}
        </button>
      );
    }

    return pages;
  };

  // Only show items info on larger screens, hide on very small screens to save space
  const showItemsInfo = totalItems && itemsPerPage;

  return (
    <div className="px-3 sm:px-4 md:px-6 py-3 sm:py-4 border-t border-gray-200">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
        {/* Items info - hidden on very small screens, visible on tablet/desktop */}
        {showItemsInfo && (
          <div className="text-xs sm:text-sm text-[#6B635D] order-2 sm:order-1 text-center sm:text-left">
            Showing <span className="font-medium">{itemsPerPage}</span> out of <span className="font-medium">{totalItems}</span> items
          </div>
        )}
        
        {/* Pagination controls */}
        <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 md:gap-4 order-1 sm:order-2">
          <button 
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="p-1.5 sm:p-2 md:p-2.5 border border-[#DBDBDB] hover:border-[#1C2A46] transition-colors disabled:opacity-50 disabled:cursor-not-allowed rounded"
            aria-label="Previous page"
          >
            <ArrowLeft className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-[#1C2A46]" />
          </button>
          
          <div className="flex flex-wrap justify-center gap-1 sm:gap-2">
            {renderPageNumbers()}
          </div>
          
          <button 
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="p-1.5 sm:p-2 md:p-2.5 border border-[#DBDBDB] hover:border-[#1C2A46] transition-colors disabled:opacity-50 disabled:cursor-not-allowed rounded"
            aria-label="Next page"
          >
            <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-[#1C2A46]" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;